export default __webpack_public_path__ + "static/media/edit.89150bed.svg";